import { CmsProduct } from '../types/cmsProduct';
import { MetadataProductCard, VerticalType } from '../types/cmsTypes';

// Catalogue products carry no vertical field; the uid is
// `<MARKET>.<VERTICAL>.<PROVIDER>.<CODE>` (`HK.CC.AEON.…`), a few legacy uids
// omit the market, so the vertical code is segment 1 or 0.
const VERTICAL_BY_UID_CODE: Record<string, VerticalType> = {
  CC: 'CREDIT_CARD',
  PL: 'PERSONAL_LOANS',
  BA: 'BANKING',
  TI: 'TRAVEL_INSURANCE',
  CI: 'CAR_INSURANCE',
};

export const getVerticalByUid = (
  uid: string | undefined,
): VerticalType | undefined => {
  const [first, second] = uid?.split('.') ?? [];

  return (
    VERTICAL_BY_UID_CODE[second ?? ''] ?? VERTICAL_BY_UID_CODE[first ?? '']
  );
};

export const getProductVertical = (
  product: CmsProduct | undefined,
): VerticalType | undefined => getVerticalByUid(product?.title ?? product?.uid);

/**
 * Vertical of a block = vertical of its first product; product-less entries
 * (unpublished / removed) are skipped so a hole does not fall back to the page vertical.
 */
export const getProductsVertical = (
  products: ReadonlyArray<CmsProduct | undefined> | undefined,
): VerticalType | undefined =>
  getProductVertical(products?.find((p) => p !== undefined));

/**
 * Vertical of the ProductMetaConfig cards a block shows — `visible: false` ones
 * are skipped, the same show-unless-false rule the blocks render by.
 */
export const getProductCardsVertical = (
  cards: ReadonlyArray<MetadataProductCard> | undefined,
): VerticalType | undefined =>
  getProductsVertical(
    cards
      ?.filter((card) => card.visible !== false)
      .map((card) => card.productBlock?.product),
  );
